import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { translate } from 'react-i18next';

let baseWeb = process.env.REACT_APP_WEB_URL

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

const Footer = ({ t, isLoggedIn }) => {
    let cookie = getCookie('majak.sk-cookie')

    return (
    <footer className="footer">
        <div className="wrapper">

            <div className="footer_top text_center_lgm pdt-15 pdb-30">
                <div className="grid big-space">
                    <div className="col_default col1_lgm mgt-15">
                        <Link to="/pomoc">
                            Pomoc
                        </Link>    
                    </div>
                    <div className="col_default col1_lgm mgt-15">
                        <a href={`${baseWeb}/na-stiahnutie`}>
                            Dokumenty na stiahnutie
                        </a>    
                    </div>
                    <div className="col_default col1_lgm mgt-15">
                        <a href={`${baseWeb}/documents/Podmienky pouzivania portalu Majak.sk.pdf`} target="_blank" rel="noopener noreferrer">
                            Všeobecné zmluvné podmienky
                        </a>    
                    </div>
                    <div className="col_default col1_lgm mgt-15">
                        <a href={`${baseWeb}/cennik`}>
                            Cenník
                        </a>    
                    </div>
                </div>
            </div>

            <div className="footer_mid pdb-35 text_center_lgm">
                <div className="grid mid-space">
                    <div className="col4 col1_lgm pdt-35">
                        <h2 className="footer_title"><a href={`${baseWeb}/investicie`}>Investície</a></h2>
                        <ul className="footer_list">
                            <li>
                                <a href={`${baseWeb}/investicie`}>{t('Dôvody prečo investovať')}</a>
                            </li>
                            <li>
                                <a href={`${baseWeb}/investicie#proces-investovania`}>{t('Proces investovania')}</a>
                            </li>
                            <li>
                                <a href={`${baseWeb}/investicie#garancie-a-bezpecnost`}>{t('Garancie a bezpečnosť')}</a>
                            </li>
                            <li>
                                <a href={`${baseWeb}/investicie/poplatky-dane-odvody`}>{t('Poplatky, dane a odvody')}</a>
                            </li>
                            <li>
                                <a href={`${baseWeb}/investicie/najcastejsie-otazky`}>{t('Najčastejšie otázky investorov')}</a>
                            </li>
                        </ul>                                
                    </div>

                    <div className="col4 col1_lgm pdt-35">
                        <h2 className="footer_title"><a href={`${baseWeb}/pozicky`}>Pôžičky</a></h2>
                        <ul className="footer_list">
                            <li>
                                <a href={`${baseWeb}/pozicky`}>{t('Ako si požičať')}</a>
                            </li>
                            <li>
                                <a href={`${baseWeb}/pozicky#poplatky`}>{t('Poplatky')}</a>
                            </li>
                            <li>
                                <a href={`${baseWeb}/pozicky/najcastejsie-otazky`}>{t('Najčastejšie otázky k pôžičkám')}</a>
                            </li>
                        </ul>    
                    </div>

                    <div className="col4 col1_lgm pdt-35">                               
                        <ul className="footer_list">
                            <li>
                                <a href={`${baseWeb}/o-nas`}>
                                    <strong>O nás</strong>
                                </a>
                            </li>
                            <li>
                                <Link to="/pomoc">
                                    <strong>Pomoc</strong>
                                </Link>    
                            </li>
                            <li>
                                <a href={`${baseWeb}/o-nas#info`}>
                                    <strong>Kontakt</strong>
                                </a>
                            </li>
                            <li>
                                <a href={`${baseWeb}/documents/Podmienky pouzivania portalu Majak.sk.pdf`} target="_blank" rel="noopener noreferrer">
                                    Všeobecné zmluvné podmienky
                                </a>    
                            </li>
                        </ul>    
                    </div>

                    <div className="col4 col1_lgm pdt-35">     
                        <h2 className="footer_title"><a target="_blank" href={`${baseWeb}/o-nas#pomoc`}>Kontaktujte nás</a></h2>
                        <address className="footer_address">
                            <div>Peer2Peer, s.r.o.</div>
                            <div>Mostová 2, 811 02 Bratislava</div>
                            <div><a href="mailto:info@majak.sk">info@majak.sk</a></div>
                            <div><a href="tel:+421948971717">+421 948 97 17 17</a></div>
                        </address>   
                    </div>

                </div>
            </div>

            <div className="footer_copy pdt-25 pdb-25">
                &copy; {new Date().getFullYear()} Peer2Peer, s.r.o. <span className="nowrap">Všetky práva vyhradené</span>
            </div>
        </div>
        {/* <div id="cookie">
            <div id="cookieBar" className={`cookie-bar ${cookie !== null?'':'active'}`}>
                <p>Z dôvodu snahy poskytovať kvalitné služby, využívajú stránky cookies. Informácie o tom, ako cookies používame a ako ich môžete odmietnuť nájdete <a href={`${baseWeb}/cookies`} target="_blank">tu</a>.</p>
                <button 
                    id="cookieBarButton"
                    onClick={() => {
                        setCookie('majak.sk-cookie', 'accepted', 365)
                        document.getElementById('cookieBar').classList.remove('active')
                    }}
                >
                    Rozumiem
                </button>
            </div>
        </div> */}
    </footer>
)};

Footer.propTypes = {
    t: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
};

export default translate()(Footer);



// WEBPACK FOOTER //
// ./src/app/components/Footer.js